import React from 'react';
import classNames from 'classnames';
import Button from '../Button';
import { skipToMainContent } from '../SkipNav';

export interface ReturnToTopProps {
  children?: React.ReactNode | string;
  className?: string;
  id?: string;
}

const ReturnToTop = ({ children, className, id }: ReturnToTopProps): JSX.Element => {
  const returnToTopClasses = classNames(className, 'grid-container', 'usa-footer__return-to-top');

  return (
    <div className={returnToTopClasses} data-testid="uswds-react-return-to-top">
      <Button id={id} variant="unstyled" onClick={skipToMainContent}>
        {children}
      </Button>
    </div>
  );
};

export default ReturnToTop;
